module.exports = __webpack_public_path__ + "img/service-screen-editor.8149cecb.png";